import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm, getFormValues } from 'redux-form'
import Button from '@material-ui/core/Button'
import renderTextField from './renderTextField'
import { email } from './validation'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  buttons: {
    paddingTop: 50,
    display: 'flex',
    justifyContent: 'space-around'
  },
  fields: {

    display: 'flex',
    justifyContent: 'space-around'
  }
})

class LoginForm extends Component {
  static contextTypes = {
    store: PropTypes.object
  }

  get values () {
    const { store } = this.context
    const state = store.getState()

    return getFormValues('Login')(state)
  }

  handleForgotPassword = () => {
    const formValues = this.values
    const { email } = this.values
    const { handleForgotPassword } = this.props
    handleForgotPassword({ email })
  }

  render () {
    const { classes, handleSubmit, handleGuestSubmit, handleForgotPassword, submitting, allowGuest } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <div className={classes.fields}>
        <Field
          name='email'
          label='email'
          component={renderTextField}
          margin='normal'
          validate={[email]}
          />
        </div>
        <div className={classes.fields}>
        <Field
          name='password'
          label='password'
          component={renderTextField}
          margin='normal'
          type='password'
          />
        </div>
        <div className={classes.buttons}>
          <Button type='submit' color='primary' disabled={submitting}>
            Sign in
          </Button>
          {allowGuest &&
          <Button onClick={handleGuestSubmit} color='primary' disabled={submitting}>
            Continue as guest
            </Button>
          }
        </div>
        <div className={classes.buttons}>
          <Button onClick={this.handleForgotPassword} >Forgot password?</Button>
          </div>
      </form>
    )
  }
}

export default reduxForm({
  form: 'Login'
})(withStyles(styles)(LoginForm))



// WEBPACK FOOTER //
// ./src/forms/LoginForm.js